var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ETH_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    d: "M63 31.996c0 17.12-13.88 30.997-31 30.997S1 49.115 1 31.996C1 14.878 14.88 1 32 1s31 13.878 31 30.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M31.996 9.999 31.69 11v29.09l.306.295 13.995-7.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M31.996 9.999 18 32.404l13.996 7.982V10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "m31.996 42.943-.172.203v10.362l.172.486L46 34.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M31.996 53.994V42.943L18 34.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m31.996 40.386 13.995-7.982-13.995-6.137z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "m18 32.404 13.996 7.982v-14.12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ETH_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export { SvgEth as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzYxMDlfNDA3MCkiPgo8cGF0aCBkPSJNNjMgMzEuOTk2NEM2MyA0OS4xMTUxIDQ5LjEyMDkgNjIuOTkyOCAzMiA2Mi45OTI4QzE0Ljg3OTEgNjIuOTkyOCAxIDQ5LjExNTEgMSAzMS45OTY0QzEgMTQuODc3NyAxNC44NzkxIDEgMzIgMUM0OS4xMjA5IDEgNjMgMTQuODc3NyA2MyAzMS45OTY0WiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iI0YwRjBGMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zMS45OTU5IDkuOTk4OUwzMS42ODk5IDExLjAwMTVWNDAuMDkxN0wzMS45OTU5IDQwLjM4NjJMNDUuOTkxNCAzMi40MDQ0TDMxLjk5NTkgOS45OTg5WiIgZmlsbD0iIzM0MzQzNCIvPgo8cGF0aCBkPSJNMzEuOTk1OSA5Ljk5ODlMMTggMzIuNDA0NEwzMS45OTU5IDQwLjM4NjJWMjYuMjY2NlY5Ljk5ODlaIiBmaWxsPSIjOEM4QzhDIi8+CjxwYXRoIGQ9Ik0zMS45OTU5IDQyLjk0MjdMMzEuODIzNSA0My4xNDU2VjUzLjUwOEwzMS45OTU5IDUzLjk5MzZMNDYgMzQuOTY1MUwzMS45OTU5IDQyLjk0MjdaIiBmaWxsPSIjM0MzQzNCIi8+CjxwYXRoIGQ9Ik0zMS45OTU5IDUzLjk5MzZWNDIuOTQyN0wxOCAzNC45NjUxTDMxLjk5NTkgNTMuOTkzNloiIGZpbGw9IiM4QzhDOEMiLz4KPHBhdGggZD0iTTMxLjk5NTggNDAuMzg2Mkw0NS45OTE0IDMyLjQwNDRMMzEuOTk1OCAyNi4yNjY2VjQwLjM4NjJaIiBmaWxsPSIjMTQxNDE0Ii8+CjxwYXRoIGQ9Ik0xOCAzMi40MDQ0TDMxLjk5NTkgNDAuMzg2MlYyNi4yNjY2TDE4IDMyLjQwNDRaIiBmaWxsPSIjMzkzOTM5Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNjEwOV80MDcwIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";